export class KeyValueDTO {
    key: string;
    value: string;

    constructor(
        key: string = "",
        value: string = "",
    ) {
        this.key = key;
        this.value = KeyValueDTO.convertValue(value);
    }

    public static copy(destination: KeyValueDTO, source: any) : KeyValueDTO {
        if (destination.key != source.key) destination.key = source.key;
        if (typeof source.value === "string") {
            if (destination.value != source.value) destination.value = source.value;
        } else if (typeof source.value === "number") {
            if (destination.value != source.value.toString()) destination.value = source.value.toString();
        } else if (Array.isArray(source.value)) {
            destination.value = source.value.join(', ');
        }
        return destination;
    }

    public static convertValue(value: any) : string {
        if (typeof value === "string") {
            return value;
        } else if (Array.isArray(value)) {
            value.join(', ');
        }
        return value.toString();
    }
}